import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { ActionType } from './action-type';

export class ProcessStage implements ViewModel {
  friendlyTypeNameSingular: string = 'Process Stage';
  apiRoute: string = CONFIG.apiRoutes.eventProcessStages;

  id: string;
  processId: string;
  name: string;
  rowOrder: number;
  startStage: boolean;
  endStage: boolean;
  action: number; 
  actionLabel?: string; 
  completionActionTypeId?: number; 
  public actionType: ActionType; 

  
  json() {
    return {
      id: this.id,
      processId: this.processId,
      name: this.name,
      rowOrder: this.rowOrder,
      startStage: this.startStage,
      endStage: this.endStage,
      completionActionTypeId: this.completionActionTypeId || null,
      actionType: this.actionType || null, 
    };
  }


  loadFromJson(data: any) {
    this.id = data.id;
    this.processId = data.processId;
    this.name = data.name;
    this.rowOrder = data.rowOrder;
    this.startStage = data.startStage;
    this.endStage = data.endStage;
    this.completionActionTypeId = data.completionActionTypeId; 
    this.actionType = data.actionType;
    this.action = data.completionActionTypeId;
    this.actionLabel = data.actionType?.name;
  }
}
